import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <a href="#" class="wc-anchor-payload-pill aPayload text-decoration-none small d-inline-block me-1 mb-1 text-nowrap">
    <span class="wc-anchor-payload-pill-start p-1 rounded-start">Link</span>
    <span class="wc-anchor-payload-pill-end p-1 rounded-end">0</span>
  </a>
`;

export class WCAnchorPayloadPill extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcAnchorPayloadPill = clone.content.querySelector('.wc-anchor-payload-pill').cloneNode(false);
    let wcAnchorPayloadPillStart = clone.content.querySelector('.wc-anchor-payload-pill-start').cloneNode(false);
    let wcAnchorPayloadPillEnd = clone.content.querySelector('.wc-anchor-payload-pill-end').cloneNode(false);
    let dataHref = this.getAttribute('data-href');
    let dataIcon = this.getAttribute('data-icon');
    let dataValue = this.getAttribute('data-value');
    let dataPayload = $$.tool.dataJSON(this.getAttribute('data-payload'));
    let grayed = dataValue !== null && Number(dataValue) === 0;
    wcAnchorPayloadPill.dataset.payload = encodeURIComponent(JSON.stringify(dataPayload));
    wcAnchorPayloadPill.setAttribute('href', CI.base_url + dataHref);
    if (dataIcon !== null) {
      let wcAnchorPayloadPillIcon = document.createElement('i');
      wcAnchorPayloadPillIcon.classList.add(dataIcon);
      wcAnchorPayloadPillStart.append(wcAnchorPayloadPillIcon);
      wcAnchorPayloadPillStart.append(document.createTextNode(' '));
    }
    contentNodes.forEach(node => {
      wcAnchorPayloadPillStart.append(node);
    });
    if (grayed) {
      wcAnchorPayloadPill.classList.add('text-gray-500');
      wcAnchorPayloadPillStart.classList.add('bg-gray-200');
      wcAnchorPayloadPillEnd.classList.add('bg-gray-200');
    } else {
      wcAnchorPayloadPillStart.classList.add('text-bg-primary');
      wcAnchorPayloadPillEnd.classList.add('text-bg-gray-300');
    }
    if (dataValue !== null) {
      wcAnchorPayloadPillEnd.append(dataValue);
    } else {
      wcAnchorPayloadPillStart.classList.add('rounded-end');
    }
    wcAnchorPayloadPill.append(wcAnchorPayloadPillStart);
    if (dataValue !== null) {
      wcAnchorPayloadPill.append(wcAnchorPayloadPillEnd);
    }
    // this.innerHTML = '';
    this.replaceWith(wcAnchorPayloadPill);
  }

}